import type { models } from 'cesg-shared';
import { appHttpService } from '../standard/http-service';

class AdminFortnoxUsersService {
  async getUsersAndProjects() {
    return await appHttpService.request
      .url(`/admin-fortnox-users/projects`)
      .get()
      .json<models.GetAdminUsersAndProjectsResponse>();
  }

  async updateUser(userId: string, body: models.PutAdminUserRequest) {
    return await appHttpService.request
      .url(`/admin-fortnox-users/${userId}`)
      .put(body)
      .res();
  }
}

export const adminFortnoxUsersService = new AdminFortnoxUsersService();
